import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';

export class AboutHomeController {
  private memberConfigs: Record<string, any>;
  private memberFeatures: Record<string, any>;
  private appVersion: Record<string, any>;
  private target: string;
  private browser: string;
  constructor(private appConfigModel: any, private Configuration: any, private $state: ng.ui.IStateService) {
    this.memberConfigs = appConfigModel.model.member_configs;
    this.memberFeatures = appConfigModel.model.member_features;
    this.appVersion = this.Configuration.read('about').version;
    this.target = _4.get(this.Configuration.read('target'), 'environment', '');
    this.browser = this.detectBrowser();
  }

  isMobile(): boolean {
    return PlatformUtility.isMobile();
  }

  isIOS(): boolean {
    return PlatformUtility.isIOS();
  }

  getImageSource(): string {
    if (this.isMobile()) {
      return 'res/navigate.png';
    } else {
      return './b073051cd2664d36/res/navigate.png';
    }
  }

  private detectBrowser() {
    // https://stackoverflow.com/questions/5916900/how-can-you-detect-the-version-of-a-browser?answertab=active#tab-top
    const ua = navigator.userAgent;
    let tem;
    let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem !== undefined && tem !== null) {
        return tem.slice(1).join(' ').replace('OPR', 'Opera');
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    // tslint:disable-next-line:triple-equals
    if ((tem = ua.match(/version\/(\d+)/i)) != undefined) {
      M.splice(1, 1, tem[1]);
    }
    return M.join(' ');
  }
}
export class AboutHomeComponent implements ng.IComponentOptions {
  public controller: object = AboutHomeController;
  public templateUrl: string = 'capability-ng-settings/src/about/components/about_home/about_home.html';
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-settings/src/about/components/about_home/about_home.ts